import images from "./images";
let reviews = [
{
name: "Waleed Alkathiri ",
position: "Udemy student",
image: images.avatar1,
review:
"To find a comprehensive react.js course that teaches you all what you need to start"
},
{
name: "Vishal Sharma",
position: "Udemy student",
image: images.avatar2,
review:
"This is the best course. Deeply explaining every concept as well as simply explaining"
},
{
name: "Sahil Khan",
position: "Udemy student",
image: images.avatar3,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan4",
position: "Udemy student",
image: images.avatar4,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan5",
position: "Udemy student",
image: images.avatar5,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan6",
position: "Udemy student",
image: images.avatar6,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan7",
position: "Udemy student",
image: images.avatar7,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan8",
position: "Udemy student",
image: images.avatar8,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan9",
position: "Udemy student",
image: images.avatar9,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan10",
position: "Udemy student",
image: images.avatar10,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
{
name: "Sahil Khan11",
position: "Udemy student",
image: images.avatar11,
review: 
"Best React course on Udemy. The way he explained every topic is just awesome. I learned"
},
];
export {reviews};